import React from 'react';
import SelectConfig from '../../controllers/SelectConfig';
import SaveChanges from '../../controllers/SaveChanges';
import { useFormWatch } from '../../../../../../helpers/formManager';
import { fieldNames } from '../../../../shared/configs/acceptanceForm';
import { formatDate } from '../../../../shared/packages/dateTime';
import Period from '../../../../shared/ui/Period';
import CancelChanges from '../../controllers/CancelChanges';
import styles from './index.module.scss';

const Header = () => {
  return (
    <>
      <div className={styles.col}>
        <SelectConfig />
        <PeriodBlock />
      </div>

      <div className={styles.col}>
        <CancelChanges />
        <SaveChanges />
      </div>
    </>
  );
};

export default Header;

function PeriodBlock() {
  const [fromDate, toDate] = useFormWatch({
    name: [fieldNames.main.fromDate, fieldNames.main.toDate],
  });

  return fromDate && toDate ? (
    <Period fromDate={formatDate(fromDate)} toDate={formatDate(toDate)} />
  ) : null;
}
